import { Check } from "lucide-react";

const STEPS = [["disiapkan", "Disiapkan"], ["dikirim", "Dikirim"], ["diterima", "Diterima"]];

export function ShipmentStatus({ status, receivedBy, testid }) {
  const idx = STEPS.findIndex(([k]) => k === status);
  return (
    <div className="flex items-center gap-1 flex-wrap" data-testid={testid}>
      {STEPS.map(([k, l], i) => {
        const done = i <= idx;
        return (
          <div key={k} className="flex items-center gap-1">
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border ${done ? (k === "diterima" ? "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" : "bg-sky-500/15 text-sky-500 border-sky-500/30") : "bg-muted text-muted-foreground border-border"}`}>
              {done && <Check className="w-3 h-3" />}{l}
            </span>
            {i < STEPS.length - 1 && <span className={`w-3 h-px ${i < idx ? "bg-sky-500" : "bg-border"}`} />}
          </div>
        );
      })}
      {status === "diterima" && receivedBy && <span className="text-[10px] text-muted-foreground ml-1">oleh {receivedBy}</span>}
    </div>
  );
}
